module.exports = __webpack_public_path__ + "img/dr_5.0ee4c437.png";